export enum LayoutTypes {
	Penalty = "penalty",
	TollRoads = "toll_road_bill",
}
